export const MAX_HEADING_WORD_LENGTH = 8;
